import './PuxNavigation.scss'

import { Link } from 'gatsby'
import React, { FunctionComponent, ReactElement } from 'react'
import PuxIconBuilder from 'Shared/components/PuxIconBuilder/PuxIconBuilder'
import { KnowledgeBaseMenuItemType } from 'Shared/utils/getKnowledgeBaseData'
import { getHrefLang, getLocalizedUrl } from 'Shared/utils/localeURL'

export interface ContentLinkType {
  internal: boolean[]
  text: string
  url: string
}

export interface CustomContentLinkType extends ContentLinkType {
  children?: ContentLinkType[]
}

export interface SideCardNavigationLinkType {
  contentType?: string
  contentItemId?: string
  sideCardNavigationLinkItem: ContentLinkType
  sideCardNavigationLinkNewWindow: boolean
  sideCardNavigationLinkIcon: string
}

interface PuxNavigationType {
  type: 'widget'
  items: SideCardNavigationLinkType[]
}

interface KnowledgeBaseNavigationType {
  type: 'knowledgeBase'
  items: KnowledgeBaseMenuItemType[]
}

type NavigationType = PuxNavigationType | KnowledgeBaseNavigationType

const rootClass = `pux-navigation`

const getNavigationComponent = (
  props: NavigationType
): ReactElement<null, ''> | null => {
  if (!props.items) {
    return null
  }

  switch (props.type) {
    case `widget`:
      return (
        <>
          {props.items.map((item, idx) => (
            <li className={`${rootClass}-item`} key={idx}>
              {item.sideCardNavigationLinkItem.internal[0] && (
                <Link
                  activeClassName={`is-active`}
                  className={`${rootClass}-link`}
                  target={`
                    ${item.sideCardNavigationLinkNewWindow ? `_blank` : `_self`}
                    `}
                  to={getLocalizedUrl(
                    Array.isArray(item.sideCardNavigationLinkItem?.url)
                      ? item.sideCardNavigationLinkItem?.url[0]
                      : item.sideCardNavigationLinkItem?.url
                  )}
                >
                  <span>{item.sideCardNavigationLinkItem?.text}</span>
                  {getIcon(item.sideCardNavigationLinkIcon)}
                </Link>
              )}
              {!item.sideCardNavigationLinkItem.internal[0] && (
                <a
                  href={
                    Array.isArray(item.sideCardNavigationLinkItem?.url)
                      ? item.sideCardNavigationLinkItem?.url[0]
                      : item.sideCardNavigationLinkItem?.url
                  }
                  target={`
                    ${item.sideCardNavigationLinkNewWindow ? `_blank` : `_self`}
                    `}
                  className={`${rootClass}-link`}
                >
                  <span>{item.sideCardNavigationLinkItem?.text}</span>
                  {getIcon(item.sideCardNavigationLinkIcon)}
                </a>
              )}
            </li>
          ))}
        </>
      )
    case `knowledgeBase`:
      return (
        <>
          {props.items.map((item, idx) => {
            const activeClass = item.isActive ? ` has-submenu` : ``

            return (
              <li className={`${rootClass}-item${activeClass}`} key={idx}>
                {getKnowledgeBaseLinkItem(item, true)}
                {item.isActive && item.menuItemsList && (
                  <ul className={`${rootClass}-submenu`}>
                    {item.menuItemsList.map((subItem, idxx) => (
                      <li className={`${rootClass}-subitem`} key={idxx}>
                        {getKnowledgeBaseLinkItem(subItem, false)}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            )
          })}
        </>
      )

    default:
      return null
  }
}

const getKnowledgeBaseLinkItem = (
  linkItem: KnowledgeBaseMenuItemType,
  icon: boolean
) => (
  <Link
    activeClassName={`is-active`}
    className={`${rootClass}-link`}
    to={getLocalizedUrl(linkItem.path)}
  >
    <span>{linkItem.displayText}</span>
    {icon && getIcon(`ArrowRight`)}
  </Link>
)

const getIcon = (icon: string) => {
  switch (icon) {
    case `download`:
      return <PuxIconBuilder icon='DownloadIcon' />
    case `none`:
      return null
    default:
      return <PuxIconBuilder icon='ArrowRightIcon' />
  }
}

const PuxNavigation: FunctionComponent<NavigationType> = (props) => (
  <ul className={rootClass}>{getNavigationComponent(props)}</ul>
)

export default PuxNavigation
